export type CityPage = {
  slug: string;
  name: string;
  canton: string;
  cantonName: string;
  intro: string;
  context: string;
  topics: string[];
  nearby: string[];
};

export const cityPages: CityPage[] = [
  {
    slug: "basel",
    name: "Basel",
    canton: "bs",
    cantonName: "Basel-Stadt",
    intro:
      "In Basel prägen Altbauwohnungen, Stadthäuser und dicht bebaute Quartiere viele Bauvorhaben. Begner hilft Ihnen, passende Handwerker für Sanierung, Unterhalt und Umbau in der Region zu finden.",
    context:
      "Bei Altbauten in Basel lohnt sich eine frühe Klärung von Bewilligungen, Denkmalpflege und Zugang zur Baustelle. Beschreiben Sie diese Punkte direkt in Ihrer Anfrage.",
    topics: ["Altbausanierung", "Badumbau", "Malerarbeiten", "Fenster ersetzen"],
    nearby: ["baselland", "solothurn", "aargau"],
  },
  {
    slug: "baselland",
    name: "Baselland",
    canton: "bl",
    cantonName: "Basel-Landschaft",
    intro:
      "Im Baselbiet stehen viele Einfamilienhäuser aus den 1960er bis 1990er Jahren vor der nächsten Erneuerung. Auf Begner beschreiben Sie Ihr Projekt einmal und erhalten Rückmeldungen von Betrieben aus der Region.",
    context:
      "Häufige Themen sind Heizungsersatz, Dachsanierung und Küchenumbau. Fotos vom heutigen Zustand helfen Betrieben, realistische Offerten zu machen.",
    topics: ["Heizungsersatz", "Dachsanierung", "Küchenumbau", "Gartenbau"],
    nearby: ["basel", "solothurn", "aargau"],
  },
  {
    slug: "solothurn",
    name: "Solothurn",
    canton: "so",
    cantonName: "Solothurn",
    intro:
      "Ob Altstadtwohnung in Solothurn oder Einfamilienhaus im Wasseramt: Begner bringt Ihr Bauprojekt mit Handwerkern aus dem Kanton zusammen.",
    context:
      "Geben Sie in Ihrer Anfrage an, ob es sich um eine Mietwohnung, Stockwerkeigentum oder ein eigenes Haus handelt. So wissen Betriebe sofort, wer entscheidet.",
    topics: ["Renovation", "Bodenbeläge", "Elektroinstallationen", "Fassade"],
    nearby: ["bern", "aargau", "baselland"],
  },
  {
    slug: "aargau",
    name: "Aargau",
    canton: "ag",
    cantonName: "Aargau",
    intro:
      "Im Aargau wird viel gebaut und erneuert, von Aarau über Baden bis ins Freiamt. Mit Begner finden Sie Handwerker für kleine Reparaturen ebenso wie für grössere Umbauten.",
    context:
      "Für energetische Sanierungen gibt es kantonale Förderprogramme. Klären Sie Förderbeiträge, bevor Sie einen Auftrag vergeben.",
    topics: ["Wärmepumpe", "Fassadendämmung", "Badumbau", "Plattenleger"],
    nearby: ["zuerich", "solothurn", "luzern"],
  },
  {
    slug: "zuerich",
    name: "Zürich",
    canton: "zh",
    cantonName: "Zürich",
    intro:
      "In Zürich sind Handwerker gefragt und Termine oft knapp. Begner hilft Ihnen, Ihr Projekt klar zu beschreiben und passende Betriebe aus Stadt und Kanton zu erreichen.",
    context:
      "Je genauer Masse, Zeitraum und Budgetrahmen in Ihrer Anfrage stehen, desto schneller kommen vergleichbare Offerten. Planen Sie bei Mehrfamilienhäusern die Verwaltung frühzeitig ein.",
    topics: ["Wohnungsrenovation", "Küchenumbau", "Malerarbeiten", "Umzugsreinigung"],
    nearby: ["aargau", "st-gallen", "luzern"],
  },
  {
    slug: "bern",
    name: "Bern",
    canton: "be",
    cantonName: "Bern",
    intro:
      "Vom Berner Altstadthaus bis zum Chalet im Oberland: Der Kanton Bern bietet sehr unterschiedliche Bauaufgaben. Begner verbindet Sie mit Handwerkern aus Ihrer Region.",
    context:
      "In der Berner Altstadt gelten strenge Vorgaben für Fassaden und Fenster. Erwähnen Sie das in Ihrer Anfrage, damit sich erfahrene Betriebe melden.",
    topics: ["Fenster ersetzen", "Heizungsersatz", "Schreinerarbeiten", "Badumbau"],
    nearby: ["solothurn", "luzern", "lausanne"],
  },
  {
    slug: "luzern",
    name: "Luzern",
    canton: "lu",
    cantonName: "Luzern",
    intro:
      "In Luzern und der Zentralschweiz finden Sie über Begner Handwerker für Renovation, Unterhalt und Ausbau. Eine Anfrage genügt, um mehrere Betriebe zu erreichen.",
    context:
      "Viele Projekte betreffen Stockwerkeigentum. Prüfen Sie vorab, welche Arbeiten die Eigentümergemeinschaft genehmigen muss.",
    topics: ["Renovation", "Bodenbeläge", "Elektroinstallationen", "Gartenbau"],
    nearby: ["zuerich", "aargau", "bern"],
  },
  {
    slug: "st-gallen",
    name: "St. Gallen",
    canton: "sg",
    cantonName: "St. Gallen",
    intro:
      "In St. Gallen und der Ostschweiz finden Sie über Begner Handwerker für Ihr Bau- oder Sanierungsprojekt, ob in der Stadt oder auf dem Land.",
    context:
      "Bei älteren Häusern lohnt sich vor einer Sanierung eine Energieberatung. Sie zeigt, welche Massnahmen am meisten bringen.",
    topics: ["Energetische Sanierung", "Dachsanierung", "Badumbau", "Malerarbeiten"],
    nearby: ["zuerich", "chur", "aargau"],
  },
  {
    slug: "chur",
    name: "Chur",
    canton: "gr",
    cantonName: "Graubünden",
    intro:
      "In Chur und Graubünden stellen Höhenlage, Schnee und Zufahrt eigene Anforderungen an Bauprojekte. Begner hilft Ihnen, Betriebe mit regionaler Erfahrung zu finden.",
    context:
      "Planen Sie Aussenarbeiten in Berglagen früh, da die Bausaison kürzer ist. Geben Sie Höhe und Zufahrt in Ihrer Anfrage an.",
    topics: ["Dachsanierung", "Holzbau", "Heizungsersatz", "Schreinerarbeiten"],
    nearby: ["st-gallen", "zuerich", "lugano"],
  },
  {
    slug: "lausanne",
    name: "Lausanne",
    canton: "vd",
    cantonName: "Waadt",
    intro:
      "In Lausanne und der Waadt finden Sie über Begner Handwerker für Renovation und Unterhalt. Ihre Anfrage erreicht Betriebe aus der Region.",
    context:
      "Viele Betriebe in der Romandie arbeiten auf Französisch. Eine kurze Projektbeschreibung auf Französisch kann die Rückmeldungen beschleunigen.",
    topics: ["Wohnungsrenovation", "Malerarbeiten", "Badumbau", "Fenster ersetzen"],
    nearby: ["genf", "bern", "solothurn"],
  },
  {
    slug: "genf",
    name: "Genf",
    canton: "ge",
    cantonName: "Genf",
    intro:
      "In Genf ist der Wohnraum knapp und Renovationen müssen gut geplant sein. Begner verbindet Sie mit Handwerkern aus dem Kanton Genf.",
    context:
      "Bei Mietwohnungen braucht es für viele Arbeiten die Zustimmung der Verwaltung. Klären Sie das vor der Offertanfrage.",
    topics: ["Wohnungsrenovation", "Küchenumbau", "Elektroinstallationen", "Reinigung"],
    nearby: ["lausanne", "bern", "solothurn"],
  },
  {
    slug: "lugano",
    name: "Lugano",
    canton: "ti",
    cantonName: "Tessin",
    intro:
      "In Lugano und im Tessin finden Sie über Begner Handwerker für Ferienwohnungen, Rustici und Wohnhäuser.",
    context:
      "Wenn Sie nicht vor Ort wohnen, beschreiben Sie, wie Betriebe Zugang zum Objekt erhalten und wer Besichtigungen begleitet.",
    topics: ["Renovation", "Gartenbau", "Malerarbeiten", "Hauswartung"],
    nearby: ["chur", "luzern", "zuerich"],
  },
  {
    slug: "winterthur",
    name: "Winterthur",
    canton: "zh",
    cantonName: "Zürich",
    intro:
      "In Winterthur treffen Industriebauten, Arbeitersiedlungen und neue Wohnquartiere aufeinander. Begner hilft Ihnen, passende Handwerker aus der Region zu finden.",
    context:
      "Bei Siedlungshäusern aus der Gründerzeit lohnt sich ein Blick auf Leitungen und Dämmung, bevor neue Oberflächen entstehen.",
    topics: ["Altbausanierung", "Heizungsersatz", "Malerarbeiten", "Badumbau"],
    nearby: ["zuerich", "schaffhausen", "frauenfeld"],
  },
  {
    slug: "zug",
    name: "Zug",
    canton: "zg",
    cantonName: "Zug",
    intro:
      "In Zug sind Wohnungen und Häuser oft hochwertig ausgebaut und Termine bei Betrieben gefragt. Begner hilft Ihnen, passende Handwerker aus der Region zu finden.",
    context:
      "Bei Stockwerkeigentum am See gelten oft strenge Reglemente. Klären Sie Umbauten früh mit der Verwaltung.",
    topics: ["Küchenumbau", "Bodenbeläge", "Elektroinstallationen", "Badumbau"],
    nearby: ["luzern", "schwyz", "zuerich"],
  },
  {
    slug: "schwyz",
    name: "Schwyz",
    canton: "sz",
    cantonName: "Schwyz",
    intro:
      "Vom Talkessel Schwyz bis an den Zürichsee bietet der Kanton sehr unterschiedliche Bauaufgaben. Begner hilft Ihnen, passende Handwerker aus der Region zu finden.",
    context:
      "In Hanglagen sind Zufahrt und Platz für Gerüste wichtig. Erwähnen Sie das in Ihrer Anfrage.",
    topics: ["Holzbau", "Dachsanierung", "Fassade", "Gartenbau"],
    nearby: ["zug", "altdorf", "glarus"],
  },
  {
    slug: "altdorf",
    name: "Altdorf",
    canton: "ur",
    cantonName: "Uri",
    intro:
      "In Altdorf und im Kanton Uri prägen Bergtäler und Wetter viele Bauprojekte. Begner hilft Ihnen, passende Handwerker aus der Region zu finden.",
    context:
      "Die Bausaison für Aussenarbeiten ist kürzer. Planen Sie Dach und Fassade rechtzeitig.",
    topics: ["Dachsanierung", "Holzbau", "Heizungsersatz", "Fenster ersetzen"],
    nearby: ["schwyz", "stans", "chur"],
  },
  {
    slug: "stans",
    name: "Stans",
    canton: "nw",
    cantonName: "Nidwalden",
    intro:
      "In Stans und Nidwalden finden Sie über Begner Betriebe für Unterhalt und Renovation. Begner hilft Ihnen, passende Handwerker aus der Region zu finden.",
    context: "Viele Häuser liegen in Hanglage oder am See. Beschreiben Sie Lage und Zugang genau.",
    topics: ["Renovation", "Gartenbau", "Malerarbeiten", "Fenster ersetzen"],
    nearby: ["sarnen", "luzern", "altdorf"],
  },
  {
    slug: "sarnen",
    name: "Sarnen",
    canton: "ow",
    cantonName: "Obwalden",
    intro:
      "In Sarnen und Obwalden verbindet Begner Sie mit Handwerkern aus der Zentralschweiz. Begner hilft Ihnen, passende Handwerker aus der Region zu finden.",
    context: "Bei älteren Bauernhäusern lohnt sich eine Abklärung zur Bausubstanz vor dem Umbau.",
    topics: ["Holzbau", "Schreinerarbeiten", "Heizungsersatz", "Badumbau"],
    nearby: ["stans", "luzern", "bern"],
  },
  {
    slug: "glarus",
    name: "Glarus",
    canton: "gl",
    cantonName: "Glarus",
    intro:
      "In Glarus stehen viele Wohnhäuser aus der Textilzeit vor einer Erneuerung. Begner hilft Ihnen, passende Handwerker aus der Region zu finden.",
    context: "Prüfen Sie bei historischen Bauten früh die Vorgaben der Gemeinde.",
    topics: ["Altbausanierung", "Fassade", "Heizungsersatz", "Malerarbeiten"],
    nearby: ["schwyz", "st-gallen", "chur"],
  },
  {
    slug: "schaffhausen",
    name: "Schaffhausen",
    canton: "sh",
    cantonName: "Schaffhausen",
    intro:
      "In Schaffhausen prägen Altstadt mit Erkern und ländliche Dörfer das Bild. Begner hilft Ihnen, passende Handwerker aus der Region zu finden.",
    context: "In der Altstadt gelten Vorgaben zum Ortsbild. Erwähnen Sie dies in Ihrer Anfrage.",
    topics: ["Fenster ersetzen", "Fassade", "Badumbau", "Malerarbeiten"],
    nearby: ["winterthur", "frauenfeld", "zuerich"],
  },
  {
    slug: "frauenfeld",
    name: "Frauenfeld",
    canton: "tg",
    cantonName: "Thurgau",
    intro:
      "Im Thurgau stehen viele Einfamilienhäuser und Bauernhäuser zur Sanierung an. Begner hilft Ihnen, passende Handwerker aus der Region zu finden.",
    context:
      "Für Wärmepumpen und Dämmung gibt es kantonale Förderbeiträge. Klären Sie diese vorab.",
    topics: ["Wärmepumpe", "Dachsanierung", "Gartenbau", "Küchenumbau"],
    nearby: ["winterthur", "st-gallen", "schaffhausen"],
  },
  {
    slug: "herisau",
    name: "Herisau",
    canton: "ar",
    cantonName: "Appenzell Ausserrhoden",
    intro:
      "In Herisau und Ausserrhoden prägen typische Holzhäuser mit Schindelfassaden die Region. Begner hilft Ihnen, passende Handwerker aus der Region zu finden.",
    context:
      "Bei Appenzellerhäusern sind erfahrene Holzbauer gefragt. Fotos der Fassade helfen sehr.",
    topics: ["Holzbau", "Fassade", "Fenster ersetzen", "Schreinerarbeiten"],
    nearby: ["appenzell", "st-gallen", "frauenfeld"],
  },
  {
    slug: "appenzell",
    name: "Appenzell",
    canton: "ai",
    cantonName: "Appenzell Innerrhoden",
    intro:
      "In Appenzell finden Sie über Begner Betriebe, die mit traditionellen Bauweisen vertraut sind. Begner hilft Ihnen, passende Handwerker aus der Region zu finden.",
    context: "Für Ortsbild-Schutzzonen braucht es oft eine Bewilligung. Klären Sie das früh.",
    topics: ["Holzbau", "Schreinerarbeiten", "Malerarbeiten", "Dachsanierung"],
    nearby: ["herisau", "st-gallen", "glarus"],
  },
  {
    slug: "thun",
    name: "Thun",
    canton: "be",
    cantonName: "Bern",
    intro:
      "In Thun und im Berner Oberland reichen die Projekte von Seewohnungen bis zu Chalets. Begner hilft Ihnen, passende Handwerker aus der Region zu finden.",
    context: "Bei Ferienwohnungen hilft es, eine Kontaktperson vor Ort anzugeben.",
    topics: ["Renovation", "Holzbau", "Heizungsersatz", "Badumbau"],
    nearby: ["bern", "biel", "sarnen"],
  },
  {
    slug: "biel",
    name: "Biel/Bienne",
    canton: "be",
    cantonName: "Bern",
    intro:
      "In der zweisprachigen Stadt Biel finden Sie über Begner Handwerker auf Deutsch und Französisch. Begner hilft Ihnen, passende Handwerker aus der Region zu finden.",
    context: "Geben Sie an, in welcher Sprache Sie kommunizieren möchten.",
    topics: ["Wohnungsrenovation", "Elektroinstallationen", "Malerarbeiten", "Bodenbeläge"],
    nearby: ["bern", "solothurn", "neuenburg"],
  },
  {
    slug: "freiburg",
    name: "Freiburg",
    canton: "fr",
    cantonName: "Freiburg",
    intro:
      "In Freiburg und im Sense- und Seebezirk verbindet Begner Sie mit Betrieben aus der Region. Begner hilft Ihnen, passende Handwerker aus der Region zu finden.",
    context: "Viele Betriebe arbeiten zweisprachig. Nennen Sie Ihre bevorzugte Sprache.",
    topics: ["Renovation", "Heizungsersatz", "Fassade", "Küchenumbau"],
    nearby: ["bern", "lausanne", "neuenburg"],
  },
  {
    slug: "neuenburg",
    name: "Neuenburg",
    canton: "ne",
    cantonName: "Neuenburg",
    intro:
      "In Neuenburg und im Jurabogen stehen viele ältere Stadthäuser vor einer Sanierung. Begner hilft Ihnen, passende Handwerker aus der Region zu finden.",
    context: "Im Jura sind Winter lang. Planen Sie Aussenarbeiten im Sommerhalbjahr.",
    topics: ["Altbausanierung", "Fenster ersetzen", "Heizungsersatz", "Malerarbeiten"],
    nearby: ["biel", "freiburg", "delsberg"],
  },
  {
    slug: "delsberg",
    name: "Delsberg",
    canton: "ju",
    cantonName: "Jura",
    intro:
      "In Delsberg und im Kanton Jura finden Sie über Begner Handwerker für Haus und Wohnung. Begner hilft Ihnen, passende Handwerker aus der Region zu finden.",
    context: "Viele Betriebe sprechen Französisch. Eine kurze Beschreibung auf Französisch hilft.",
    topics: ["Renovation", "Dachsanierung", "Bodenbeläge", "Gartenbau"],
    nearby: ["neuenburg", "basel", "solothurn"],
  },
  {
    slug: "sitten",
    name: "Sitten",
    canton: "vs",
    cantonName: "Wallis",
    intro:
      "Im Wallis reichen Bauaufgaben von Weinbergshäusern bis zu Chalets in den Skiorten. Begner hilft Ihnen, passende Handwerker aus der Region zu finden.",
    context: "Höhe, Zufahrt und Saison bestimmen den Ablauf. Geben Sie diese Punkte an.",
    topics: ["Holzbau", "Dachsanierung", "Heizungsersatz", "Renovation"],
    nearby: ["lausanne", "thun", "genf"],
  },
  {
    slug: "bellinzona",
    name: "Bellinzona",
    canton: "ti",
    cantonName: "Tessin",
    intro:
      "In Bellinzona und im Sopraceneri finden Sie Betriebe für Häuser, Rustici und Wohnungen. Begner hilft Ihnen, passende Handwerker aus der Region zu finden.",
    context:
      "Viele Betriebe arbeiten auf Italienisch. Fotos und Masse erleichtern die Verständigung.",
    topics: ["Renovation", "Gartenbau", "Fassade", "Malerarbeiten"],
    nearby: ["lugano", "chur", "altdorf"],
  },
];

export function getCityPage(slug: string) {
  return cityPages.find((city) => city.slug === slug);
}

/** Approximate city-centre coordinates for local geo markup. */
export const cityGeo: Record<string, { lat: number; lng: number }> = {
  basel: { lat: 47.5596, lng: 7.5886 },
  baselland: { lat: 47.4846, lng: 7.7341 },
  solothurn: { lat: 47.2088, lng: 7.5323 },
  aargau: { lat: 47.3925, lng: 8.0442 },
  zuerich: { lat: 47.3769, lng: 8.5417 },
  bern: { lat: 46.948, lng: 7.4474 },
  luzern: { lat: 47.0502, lng: 8.3093 },
  "st-gallen": { lat: 47.4245, lng: 9.3767 },
  chur: { lat: 46.8508, lng: 9.532 },
  lausanne: { lat: 46.5197, lng: 6.6323 },
  genf: { lat: 46.2044, lng: 6.1432 },
  lugano: { lat: 46.0037, lng: 8.9511 },
  winterthur: { lat: 47.4988, lng: 8.7237 },
  zug: { lat: 47.1662, lng: 8.5155 },
  schwyz: { lat: 47.0207, lng: 8.6541 },
  altdorf: { lat: 46.8808, lng: 8.6444 },
  stans: { lat: 46.9579, lng: 8.3657 },
  sarnen: { lat: 46.896, lng: 8.2461 },
  glarus: { lat: 47.0404, lng: 9.068 },
  schaffhausen: { lat: 47.6973, lng: 8.6349 },
  frauenfeld: { lat: 47.5536, lng: 8.8987 },
  herisau: { lat: 47.386, lng: 9.2792 },
  appenzell: { lat: 47.3307, lng: 9.4086 },
  thun: { lat: 46.758, lng: 7.628 },
  biel: { lat: 47.1368, lng: 7.2467 },
  freiburg: { lat: 46.8065, lng: 7.162 },
  neuenburg: { lat: 46.99, lng: 6.9293 },
  delsberg: { lat: 47.365, lng: 7.3445 },
  sitten: { lat: 46.2331, lng: 7.3606 },
  bellinzona: { lat: 46.1946, lng: 9.0244 },
};
